import axios from '../Backend';

export const getAllActivitys = async () => {
    try {
        const response = await axios.get(`/api/v2/activity`);
        const resData = response.data;
        return resData;
    } catch (e) {
        console.log('axios/activityReq/getAllActivitys :: Error')
        console.log(JSON.stringify(e?.response?.data))
    }
}

export const createActivity = async (contactId, activityObject) => {
    try {
        const response = await axios.post(`/api/v2/contacts/${contactId}/activity`, activityObject);
        return response.data;
    } catch (error) {
        console.log('axios/activityReq/createActivity :: Error');
        console.log(JSON.stringify(error?.response?.data));
        return { error: error?.response?.data };
    }
}

export const editActivity = async (activityId, activityObject) => {
    try {
        const response = await axios.patch(`/api/v2/activity/${activityId}`, activityObject);
        const resData = response.data;
        return resData;
    } catch (e) {
        console.log('axios/activityReq/editActivity :: Error')
        console.log(JSON.stringify(e?.response?.data))
    }
}

export const deleteActivity = async (activityId) => {
    try {
        const response = await axios.delete(`/api/v2/activity/${activityId}`);
        const resData = response.data;
        return resData;
    } catch (e) {
        console.log('axios/activityReq/deleteActivity :: Error')
        console.log(JSON.stringify(e?.response?.data))
    }
}